/*
==========================================
Custom JS for Login page
新規作成コンポーネント用クラス
==========================================
*/

// パンくずリスト更新処理
const changeBreadcrumb = (_breadcrumb)=>{
  const login_txt = "ログイン",
    reset_pass = "パスワード登録",
    change_pass = "パスワード変更";

  if(_breadcrumb === "re_register"){
    document.querySelector('span.c-breadcrumb__link').textContent = reset_pass;
  }else if(_breadcrumb === "recover"){
    document.querySelector('span.c-breadcrumb__link').textContent = change_pass;
  }else{
    document.querySelector('span.c-breadcrumb__link').textContent = login_txt;
  }
}

// ページ表示処理
//  初期表示時・hash変更時に動作
const pageShow = () =>{
  const hash = location.hash;
  let breadcrumb = "login"
  const login_main_section = document.getElementById('login_main_section');
  const reset_pass_lead_section = document.getElementById('reset_pass_lead_section');
  const sso_section = document.querySelector('.one-click-social-login-buttons');

  if(hash === "#re_register"){
    reset_pass_lead_section.removeAttribute('hidden');
    login_main_section.setAttribute('hidden',true);
    sso_section?.setAttribute('hidden',true);
    breadcrumb="re_register";

    // Topへスクロール
    window.scroll({top: 0, behavior: 'smooth'});
  }else if(hash === "#recover"){
    login_main_section.removeAttribute('hidden');
    reset_pass_lead_section.setAttribute('hidden',true);
    sso_section?.setAttribute('hidden',true);
    breadcrumb="recover";

    // Topへスクロール
    window.scroll({top: 0, behavior: 'smooth'});
  }else{
    // パスワードリセット・アカウント再登録画面から遷移していない
    // (=ログインフォーム送信/ログインページリロード/他ページから遷移)場合、#login表示
    login_main_section.removeAttribute('hidden');
    reset_pass_lead_section.removeAttribute('hidden');
    sso_section?.removeAttribute('hidden');
    breadcrumb="login";
  }
  // パンくずリスト更新
  changeBreadcrumb(breadcrumb);
}

window.addEventListener("DOMContentLoaded",()=>{
  // 株主優待から遷移の場合
  const shareholders_flg = localStorage.getItem("shareholders_flg");
  if(shareholders_flg === "true"){
    let redirect = document.createElement('input');
    redirect.setAttribute('name', 'return_to');
    redirect.setAttribute('type', 'hidden');
    redirect.value = "/pages/mitani_shareholders";
    document.querySelector('#customer_login').appendChild(redirect);
    document.querySelector("a[href*='/account/register']").setAttribute("href","/account/register?view=mitani_shareholders");
  }

  // 株主優待から遷移の場合
  const nikko_shareholders_flg = localStorage.getItem("nikko_shareholders_flg");
  if(nikko_shareholders_flg === "true"){
    let redirect = document.createElement('input');
    redirect.setAttribute('name', 'return_to');
    redirect.setAttribute('type', 'hidden');
    redirect.value = "/pages/nikko_shareholders";
    document.querySelector('#customer_login').appendChild(redirect);
  }

  pageShow();
});
window.addEventListener("hashchange",pageShow);

// アプリ APIによりカスタマイズ
// ①送信エラー(送信した結果)：エラーを表示
// ②送信成功時：送信完了画面を表示
CF.ready(function() {
  const formId = "lXt1M5";

  // Find a CF form on the page with an ID of a34Kl0
  const $myForm = document.querySelector(`form[data-cf-form="${formId}"]`);

  // フォーム送信 : 成功事
  $myForm.addEventListener('cf:form_submitted', function(event) {
    // Topへスクロール
    window.scroll({top: 0, behavior: 'smooth'});

    var formId = event.detail.formId;
    var submissionData = event.detail.submissionData;
    const register_form = document.getElementById('re_register');

    // 成功事フォームを非表示
    register_form.setAttribute('hidden',true);
    register_form.setAttribute('style',"display:none !important;")

    // 送信成功画面を表示
    const successSubmitHTML = `
    <section class="c-login-block c-success-submit">
      <h3 class="title--primary h3 c-txt--bold">パスワード登録の<br>メールを送信しました</h3>
      <div class="c-txt__reading c-color__text c-section-description">
        <p>パスワード登録に必要なパスワード再設定のご案内メールを送信しました。<br>メールに記載されているURLよりパスワードの再設定をお願いいたします。<br><br>メールが届かないお客さまは以下をご確認ください。</p>
      </div>
      <div class="c-color__bg-primary">
        <p>・ドメイン指定をされている場合は「＠nikko-tabletop.jp」の受信設定をお願いいたします。</p>
        <p>・お客さまのメールソフトの迷惑メールボックスをご確認ください。</p>
        <p>・または、<a href="/pages/contact">こちら</a>よりお問い合わせください。</p>
      </div>
      <div class="c-submitted-form__button-wrapper c-color__text c-txt__reading">
        <a href="/" class="c-submitted-form__button c-button c-button--medium button">
        トップページへ
          <span class="c-button-icon__wrapper--absolute c-button-icon__wrapper--absolute--after"><svg class="c-icon c-icon__arrow" width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.94577 0L12.8516 4.20502H0V3.20502H10.1484L7.29498 0.759257L7.94577 0Z" fill="#1A1A1A"></path></svg></span>
        </a>
      </div>
    </section>
    `;
    register_form.insertAdjacentHTML('afterend', successSubmitHTML);
  
  });
  
    // フォーム送信 : 失敗事
    $myForm.addEventListener('cf:form_submission_failed', function(event) {
      // エラー表示がある場合削除
      const submitErrorHTML = document.getElementById('c-confirmation__error');
      if(submitErrorHTML){
        submitErrorHTML.remove();
      }
      var formId = event.detail.formId;
      var errors = Object.entries(event.detail.errors);
      let item_label = "",
        item_value = "";
  
      const errorSubmitHTML = `
        <div class="c-confirmation__error" id="c-confirmation__error">
          <ul>
            ${errors.map(item => { 
              item_label = item[0] === "email" ? "メールアドレス" : item[0];
              item_value = item[1][0] === "has already been taken" ? "すでに登録されています。" : item[1];
              return `<li>${item_label}：${item_value}</li>`
            })}
          </ul>
        </div>
      `;
      event.target.querySelector('.cf-form-actions').insertAdjacentHTML('beforebegin', errorSubmitHTML);
  
    });
});


/*
  -----------
    Start: テーマ標準フォームのバリデーション
  -----------
*/
// パスワードをお忘れの方
const submitRecoverEmail = (e) => {
  let errorFlg = false,
    errorMsg = "";
  const inputEmail = e.target.form.querySelector('#RecoverEmail');

  document.querySelectorAll('.c-error-txt').forEach(elem => elem.remove());
  document.querySelectorAll('.is-error').forEach(elem => elem.classList.remove("is-error"));

  if(inputEmail && inputEmail.value.length === 0){
    errorFlg = true;
    errorMsg = "メールアドレスが入力されていません。";
    inputEmail.insertAdjacentHTML('beforebegin', `<span class="c-error-txt">${errorMsg}</span>`);
    inputEmail.classList.add("is-error");
  }

  if(errorFlg){
    event.preventDefault();
  }
}
// サインイン
const submitSignIn = (e) => {
  let errorFlg = false,
    errorMsg = "";
  const inputEmail = e.target.form.querySelector('#CustomerEmail'),
    inputPass = e.target.form.querySelector('#CustomerPassword');

  document.querySelectorAll('.c-error-txt').forEach(elem => elem.remove());
  document.querySelectorAll('.is-error').forEach(elem => elem.classList.remove("is-error"));


  if(inputEmail && inputEmail.value.length === 0){
    errorFlg = true;
    errorMsg = "メールアドレスが入力されていません。";
    inputEmail.insertAdjacentHTML('beforebegin', `<span class="c-error-txt">${errorMsg}</span>`);
    inputEmail.classList.add("is-error");
  }
  if(inputPass && inputPass.value.length === 0){
    errorFlg = true;
    errorMsg = "パスワードが入力されていません。";
    inputPass.insertAdjacentHTML('beforebegin', `<span class="c-error-txt">${errorMsg}</span>`);
    inputPass.classList.add("is-error");
  }

  if(errorFlg){
    event.preventDefault();
  }
}

// パスワード再設定(ログイン済み)
const submitChangePass = (e) => {
  let errorFlg = false,
    errorMsg = "";
  const inputEmail = e.target.form.querySelector('#RecoverEmail');

  document.querySelectorAll('.c-error-txt').forEach(elem => elem.remove());
  document.querySelectorAll('.is-error').forEach(elem => elem.classList.remove("is-error"));

  if(inputEmail && inputEmail.value.length === 0){
    errorFlg = true;
    errorMsg = "メールアドレスが入力されていません。";
    inputEmail.insertAdjacentHTML('beforebegin', `<span class="c-error-txt">${errorMsg}</span>`);
    inputEmail.classList.add("is-error");
  }

  if(errorFlg){
    e.preventDefault();
  }
}
/*
  -----------
    End: テーマ標準フォームのバリデーション
  -----------
*/